import { on, createReducer } from '@ngrx/store';
import { addToSavedSuccess, removeFromSavedSuccess } from './saved.actions';
import { Institution } from 'src/generated/graphql';

export const savedFeatureKey = 'savedFeatureKey';

export interface SavedState {
  institutions: Institution[];
}

export const initialState: SavedState = {
  institutions: []
};

export const savedReducer = createReducer(
  initialState,

  on(addToSavedSuccess, (state, data) => ({
    ...state,
    institutions: [...state.institutions, data.institution]
  })),

  on(removeFromSavedSuccess, (state, data) => ({
    ...state,
    institutions: state.institutions.filter((item) => item.id !== data.institution.id)
  }))
);
